import { render, staticRenderFns } from "./TechnicalSketchContainer.vue?vue&type=template&id=2b0e8142"
import script from "./TechnicalSketchContainer.vue?vue&type=script&lang=js"
export * from "./TechnicalSketchContainer.vue?vue&type=script&lang=js"
import style0 from "./TechnicalSketchContainer.vue?vue&type=style&index=0&id=2b0e8142&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports